import React from 'react';
import { Switch } from 'react-router-dom';
import LoadableRoute from '../components/features/share/loadable/loadableRoute';
import { PrivateRoute, PublicRoute, DeviceRoute } from './routePermission';

//Layout
const LayoutMaster = LoadableRoute({
    loader: () => import('../components/layout/controllers/layoutMaster'),
});
const LayoutBlank = LoadableRoute({
    loader: () => import('../components/layout/controllers/layoutBlank'),
});

const LayoutBlack = LoadableRoute({
    loader: () => import('../components/layout/controllers/layoutBlack'),
});

const LayoutDisplay = LoadableRoute({
    loader: () => import('../components/layout/controllers/layoutDisplay'),
});
const LayoutPD = LoadableRoute({
    loader: () => import('../components/layout/controllers/layoutPD'),
});

//Features
//Auth
const Login = LoadableRoute({
    loader: () => import('../components/features/auth/controllers/loginController'),
});
const NotFoundController = LoadableRoute({
    loader: () => import('../components/features/auth/controllers/NotFoundController'),
});
const UnAuthenController = LoadableRoute({
    loader: () => import('../components/features/auth/controllers/UnAuthenController'),
});

// Home
const HomeController = LoadableRoute({
    loader: () => import('../components/features/home/controllers/homeController'),
});

//Display Table Task
//TableTaskController
const TableTaskController = LoadableRoute({
    loader: () => import('../components/features/displayTableTask/listTable/controllers/tableTaskController'),
});

const SetupTableController = LoadableRoute({
    loader: () => import('../components/features/displayTableTask/setupTable/controllers/setupTableController'),
});

const TableTaskOnJobSetPDController = LoadableRoute({
    loader: () => import('../components/features/displayTableTask/tableTaskOnJob/controllers/tableTaskOnJobController'),
});

const TableTaskOnJobSetWorkerController = LoadableRoute({
    loader: () => import('../components/features/displayTableTask/tableTaskOnJob/controllers/tableTaskOnJobSetWorkerController'),
});

const TableTaskOnStartController = LoadableRoute({
    loader: () => import('../components/features/displayTableTask/tableTaskOnStart/controllers/tableTaskOnStartController'),
});

const ReportAsFinishedController = LoadableRoute({
    loader: () => import('../components/features/reportAsFinish/controller/reportAsFinishController'),
    // loader: () => import('../components/features/displayTableTask/reportAsFinish/controllers/reportAsFinishedController')
});

const SetupDisplayNameController = LoadableRoute({
    loader: () => import('../components/features/displayTableTask/displayNameSetup/controllers/setupDisplayName'),
});
//PD list
const TablePDListAx = LoadableRoute({
    loader: () => import('../components/features/displayTablePDList/pdList/controllers/pdListAxController'),
});
const TablePDList = LoadableRoute({
    loader: () => import('../components/features/displayTablePDList/pdList/controllers/pdListController'),
});
const TablePDOnGoingList = LoadableRoute({
    loader: () => import('../components/features/displayTablePDList/pdList/controllers/pdOnGoingJobController'),
});
const CreateDeviceController = LoadableRoute({
    loader: () => import('../components/features/device/createDevice/controllers/createDeviceController'),
});
const UpdateDeviceController = LoadableRoute({
    loader: () => import('../components/features/device/updateDevice/controllers/updateDeviceController'),
});
const ViewDeviceController = LoadableRoute({
    loader: () => import('../components/features/device/viewDevice/controllers/viewDeviceController'),
});
const PdLoginController = LoadableRoute({
    loader: () => import('../components/features/pdLogin/controllers/pdLoginController'),
});
const PdDeviceLoginController = LoadableRoute({
    loader: () => import('../components/features/pdLogin/controllers/pdLoginDeviceController'),
});
const DrawingDeviceLoginController = LoadableRoute({
    loader: () => import('../components/features/drawingDeviceLogin/controllers/drawingDeviceLoginController'),
});
const drawingInfoController = LoadableRoute({
    loader: () => import('../components/features/drawingDeviceLogin/controllers/drawingInfoController'),
});
//listDevice
const listDeviceController = LoadableRoute({
    loader: () => import('../components/features/device/listDeivce/controllers/listDeviceController'),
});

export default () => (
    <Switch>
        {/* <PrivateRoute exact path='/masterData/settings' component={HomeController} layout={LayoutMaster} />
        <PrivateRoute exact path='/masterData' component={HomeController} layout={LayoutMaster} />*/}

        <PublicRoute path="/reportAsFinished/:id" component={ReportAsFinishedController} layout={LayoutDisplay} />
        <PublicRoute path="/taskOnStart/:id" component={TableTaskOnStartController} layout={LayoutDisplay} />
        <PublicRoute path="/taskOnJob/:id" component={TableTaskOnJobSetWorkerController} layout={LayoutDisplay} />
        <PublicRoute path="/taskOnJob" component={TableTaskOnJobSetPDController} layout={LayoutDisplay} />
        <PublicRoute path="/setup" component={SetupTableController} layout={LayoutDisplay} />
        <PublicRoute path="/table" component={TableTaskController} layout={LayoutDisplay} />

        <PrivateRoute exact path="/admin" component={HomeController} layout={LayoutMaster} />
        <PrivateRoute path="/pdList" component={TablePDList} layout={LayoutPD} onGoingJob={false} />
        <PrivateRoute path="/pdListAx" component={TablePDListAx} layout={LayoutPD} onGoingJob={false} />
        <PrivateRoute path="/listDevice" component={listDeviceController} layout={LayoutPD} />
        <PrivateRoute path="/createDevice" component={CreateDeviceController} layout={LayoutPD} onGoingJob={true} />
        <PrivateRoute path="/updateDevice/:id" component={UpdateDeviceController} layout={LayoutPD} onGoingJob={true} />
        <PrivateRoute path="/viewDevice/:id" component={ViewDeviceController} layout={LayoutPD} onGoingJob={true} />
        {/* drawingInfo */}
        <DeviceRoute path="/drawingInfo" component={drawingInfoController} layout={LayoutPD} onGoingJob={true} />
        <DeviceRoute path="/pdOnGoingJob" component={TablePDOnGoingList} layout={LayoutPD} onGoingJob={true} />

        <PublicRoute path="/drawingLogin" component={DrawingDeviceLoginController} layout={LayoutPD} onGoingJob={true} />
        <PublicRoute path="/deviceLogin" component={PdDeviceLoginController} layout={LayoutPD} onGoingJob={true} />
        <PublicRoute path="/" component={PdLoginController} layout={LayoutPD} />
        <PublicRoute path="/login" component={PdLoginController} layout={LayoutBlank} />
        <PublicRoute path="/unauthen" component={UnAuthenController} layout={LayoutMaster} />
        <PublicRoute component={NotFoundController} layout={LayoutMaster} />
    </Switch>
);



// WEBPACK FOOTER //
// ./src/app/routes/Routes.js